/**
 * Detects the old (legacy) job URL format where the entire job ID is a
 * base64-encoded source URL, e.g. aHR0cHM6Ly9jYXJlZXJzLndhcnRzaWxhLmNvbS9qb2Iv...
 *
 * The old format encoded the crawled job URL with standard or URL-safe base64.
 * The base64 encoding of any "http://" or "https://" URL always starts with:
 *   - aHR0cHM6  (base64 of "https:")
 *   - aHR0cA    (base64 of "http:")
 *
 * The new format uses short alphanumeric IDs (e.g. "job_abc123") that will
 * never match these prefixes.
 */

// base64('https:') === 'aHR0cHM6', base64('http://') === 'aHR0cDov'
const LEGACY_BASE64_PREFIXES = ['aHR0cHM6', 'aHR0cDov'];

/**
 * Returns true if the given job ID string is a legacy base64-encoded job URL.
 */
export function isLegacyBase64JobId(jobId: string): boolean {
  if (!jobId || jobId.length < 20) {
    return false;
  }
  return LEGACY_BASE64_PREFIXES.some((prefix) => jobId.startsWith(prefix));
}
